import React from "react";
import { useTheme } from "../contexts/ThemeContext";

const HeroNatural: React.FC = () => {
  const { theme } = useTheme();

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {/* Base */}
      <div
        className={`absolute inset-0 ${
          theme === "light"
            ? "bg-[#f8f9fc]"
            : "bg-[#0a0b10]"
        }`}
      />

      {/* Blue glow - top right */}
      <div
        className={`absolute -top-[15%] -right-[5%] w-[55%] h-[75%] rounded-full blur-[120px] ${
          theme === "light"
            ? "bg-blue-100/70"
            : "bg-blue-900/25"
        }`}
      />

      {/* Warm glow - center left */}
      <div
        className={`absolute top-[20%] -left-[10%] w-[40%] h-[60%] rounded-full blur-[100px] ${
          theme === "light"
            ? "bg-indigo-50/60"
            : "bg-indigo-950/20"
        }`}
      />

      {/* Subtle warm accent - bottom */}
      <div
        className={`absolute -bottom-[20%] right-[20%] w-[35%] h-[50%] rounded-full blur-[110px] ${
          theme === "light"
            ? "bg-sky-50/40"
            : "bg-blue-950/15"
        }`}
      />

      {/* Noise texture */}
      <div
        className="absolute inset-0 opacity-[0.025]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E")`,
          backgroundRepeat: "repeat",
          backgroundSize: "128px 128px",
        }}
      />
    </div>
  );
};

export default HeroNatural;
